import { InjectionToken } from '@angular/core';
import { FilterState } from '@softapps/core/filter';
import { AbcAnalysisFilterRow } from './types/abc-analysis-filter-row';

export const SOFTLINE_FILTER_WWS_ABC_ANALYSIS = new InjectionToken<
  FilterState<AbcAnalysisFilterRow>
>('SOFTLINE_FILTER_WWS_ABC_ANALYSIS');

export const SOFTLINE_API_ABC_ANALYSIS_OVERVIEW =
  '/statistics-service/statistics/abc-analysis/{{baseMeasure}}/{{abcAnalysisId}}';
export const SOFTLINE_API_ABC_ANALYSIS_PRODUCT_DETAIL =
  '/statistics-service/statistics/abc-analysis/{{baseMeasure}}/{{abcAnalysisId}}/product/{{productNumber}}';
export const SOFTLINE_API_ABC_ANALYSIS_BASE_MEASURES =
  '/statistics-service/statistics/abc-analysis/base-measures';
export const SOFTLINE_API_ABC_ANALYSIS_COLUMNS =
  '/statistics-service/statistics/abc-analysis/columns';
export const SOFTLINE_API_ABC_ANALYSIS_PRODUCT_COLUMNS =
  '/statistics-service/statistics/abc-analysis/columns/product';
export const SOFTLINE_API_ABC_ANALYSIS_FILTER_VALUES =
  '/statistics-service/statistics/abc-analysis/filter-values';
export const SOFTLINE_API_ABC_ANALYSIS_CONFIGURATIONS =
  '/statistics-service/statistics/abc-analysis/configurations';
export const SOFTLINE_API_ABC_ANALYSIS_SEGMENTS =
  '/statistics-service/statistics/abc-analysis/segments/{{abcAnalysisId}}';
